import UiGlobals from '../UiGlobals.js';

export default function setThemeOverrides(ThemeOverrides) {
	UiGlobals.ThemeOverrides = ThemeOverrides;
}
